import { render, staticRenderFns } from "./BaseBubbleWord.vue?vue&type=template&id=ba997e18&scoped=true&"
import script from "./BaseBubbleWord.vue?vue&type=script&lang=js&"
export * from "./BaseBubbleWord.vue?vue&type=script&lang=js&"
import style0 from "./BaseBubbleWord.vue?vue&type=style&index=0&id=ba997e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba997e18",
  null
  
)

export default component.exports